import { render, staticRenderFns } from "./ForumAuthorAdmin.vue?vue&type=template&id=be03da02"
import script from "./ForumAuthorAdmin.vue?vue&type=script&lang=js"
export * from "./ForumAuthorAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports